import React from "react";
import { useNavigate } from "react-router-dom";
import "./ExchangeResult.css";

const ExchangeResult = ({ requestNumber }) => {
    const navigate = useNavigate();

    return (
        <div className="exchange-result-container">
            <div className="exchange-result-card">
                <h3>Заявка сформирована</h3>
                <p className="request-id">Номер заявки: <strong>{requestNumber}</strong></p>
                <p className="instruction">
                    Для продолжения обменного процесса, обратитесь в поддержку,
                    написав номер заявки
                </p>
                <button
                    className="result-button"
                    onClick={() => navigate('/')}
                >
                    Вернуться на главную
                </button>
            </div>
        </div>
    );
};

export default ExchangeResult;